import React from "react";

const Research = () => {
  return (
    <div className="py-16 bg-white text-center">
      <h1 className="text-3xl font-bold mb-4">Research & Development</h1>
      <p className="max-w-4xl mx-auto text-gray-600">
        Our cutting-edge research focuses on sustainability and innovation in the agriculture sector. We aim to revolutionize the industry through the development of IoT-enabled systems and advanced biotechnology solutions like Guava Probi and IRIS.
      </p>
    </div>
  );
};

export default Research;
